import { render, staticRenderFns } from "./AttributeKeyFilterSettings.vue?vue&type=template&id=0a8664ce&scoped=true"
import script from "./AttributeKeyFilterSettings.vue?vue&type=script&lang=ts"
export * from "./AttributeKeyFilterSettings.vue?vue&type=script&lang=ts"
import style0 from "./AttributeKeyFilterSettings.vue?vue&type=style&index=0&id=0a8664ce&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a8664ce",
  null
  
)

export default component.exports